import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/arrears-bg.png'
import _imports_1 from '@/assets/empty.png'


const _withScopeId = n => (_pushScopeId("data-v-334ccdea"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"100%","height":"auto"}
}, null, -1))
const _hoisted_2 = { class: "num-con" }
const _hoisted_3 = { style: {"text-align":"center"} }
const _hoisted_4 = { class: "money" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"0.9rem"} }, "剩余待还", -1))
const _hoisted_6 = { style: {"padding":"2vw 0"} }
const _hoisted_7 = {
  class: "money-con",
  style: {"border-right":"1px solid #a58a00"}
}
const _hoisted_8 = {
  class: "money one-hide",
  style: {"font-size":"1rem"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"0.8rem"} }, "已还金额", -1))
const _hoisted_10 = { class: "money-con" }
const _hoisted_11 = {
  class: "money one-hide",
  style: {"font-size":"1rem"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"0.8rem"} }, "累计金额", -1))
const _hoisted_13 = { class: "btn-con" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding":"0 0.2rem"} }, "还款明细", -1))
const _hoisted_15 = { class: "main-con" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding-bottom":"0.5rem"} }, "欠款日志", -1))
const _hoisted_17 = { class: "white-radius item-con" }
const _hoisted_18 = { class: "title" }
const _hoisted_19 = { class: "item-desc" }
const _hoisted_20 = { class: "item-desc" }
const _hoisted_21 = { class: "item-desc" }
const _hoisted_22 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"70vw","height":"auto"}
}, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-tip" }, " 暂无欠款日志 ", -1))
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { style: {"padding":"0.5rem"} }
const _hoisted_27 = { class: "orderNum-con" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title",
  style: {"padding-bottom":"1rem"}
}, "请输入金额", -1))
const _hoisted_29 = { style: {"padding-bottom":"1rem"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_field = _resolveComponent("van-field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, "￥" + _toDisplayString(_ctx.data.arrearsCurrent), 1),
          _hoisted_5
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_van_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, { span: "12" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, " ￥" + _toDisplayString(_ctx.data.arrearsPaid), 1),
                    _hoisted_9
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, { span: "12" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, " ￥" + _toDisplayString(_ctx.data.arrearsTotal), 1),
                    _hoisted_12
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_van_button, {
          onClick: _ctx.repay_click,
          plain: "",
          color: "#A58A00",
          round: "",
          size: "small",
          style: {"background":"#ffffff00"}
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _hoisted_16,
      _createVNode(_component_van_list, {
        loading: _ctx.loading,
        "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loading) = $event)),
        finished: _ctx.finished,
        error: _ctx.error,
        "onUpdate:error": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.error) = $event)),
        "error-text": "加载失败，点击重试",
        onLoad: _ctx.req_items
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, _toDisplayString(item.title), 1),
              _createElementVNode("div", _hoisted_19, "欠款金额：￥" + _toDisplayString(item.payMoney), 1),
              _createElementVNode("div", _hoisted_20, "欠款订单：" + _toDisplayString(item.payCode), 1),
              _createElementVNode("div", _hoisted_21, "欠款时间：" + _toDisplayString(item.createDate), 1)
            ]))
          }), 256))
        ]),
        _: 1
      }, 8, ["loading", "finished", "error", "onLoad"]),
      (!_ctx.list.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_25))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_van_popup, {
      show: true,
      position: "bottom",
      overlay: false,
      "lock-scroll": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_van_button, {
            color: "#D8C14F",
            round: "",
            block: "",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.showPay=true), ["stop"]))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 去还款 ")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_van_popup, {
      round: "",
      show: _ctx.showPay,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showPay) = $event)),
      closeable: "",
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_van_field, {
              modelValue: _ctx.payMoney,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.payMoney) = $event)),
              type: "number",
              label: "还款金额",
              placeholder: "请输入还款金额"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_van_button, {
              round: "",
              block: "",
              color: "#D8C14F",
              onClick: _ctx.btn_click
            }, {
              default: _withCtx(() => [
                _createTextVNode("立即还款")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}